import React, {useContext, useEffect, useState} from 'react';
import { UserRecoverContext } from "./ShareStates";
import PasswordResetRequestForm from "./PasswordResetRequestForm";
import PasswordSentRequestForm from "./PasswordSentRequestForm";
import PasswordResetActionForm from "./PasswordResetActionForm";
import PasswordResetErrorForm from "./PasswordResetErrorForm";
import PasswordResetConfirmationForm from "./PasswordResetConfirmationForm";
import {useQuery} from "../../commonFunctions/commonFunctions";

const UserRecoverLandingPage = () => {
    const {displayForm, updateDisplayForm, updateToken} = useContext(UserRecoverContext);
    const [token] = useState(useQuery().get("token"));

    useEffect(() => {
        if (displayForm === "") {
            if (token === null) {
                updateDisplayForm("passwordResetRequest")
            }
            else {
                updateToken(token)
                updateDisplayForm("passwordResetAction")
            }
        }
    }, [displayForm, token, updateDisplayForm, updateToken]);

    let loadContent = null;
    if (displayForm === "passwordResetRequest") {
        loadContent = <PasswordResetRequestForm />
    }
    if (displayForm === "passwordSentRequest") {
        loadContent = <PasswordSentRequestForm />
    }
    if (displayForm === "passwordResetAction") {
        loadContent = <PasswordResetActionForm />
    }
    if (displayForm === "passwordErrorRequest") {
        loadContent = <PasswordResetErrorForm />
    }
    if (displayForm === "passwordResetConfirmation") {
        loadContent = <PasswordResetConfirmationForm />
    }
    return (
        <React.Fragment>
            {loadContent}
        </React.Fragment>
    )
}

export default UserRecoverLandingPage;